// extracted by mini-css-extract-plugin
export default {"container":"SettingsContainer_container__M7Kgb","navigation":"SettingsContainer_navigation__5cn59","navlink_container":"SettingsContainer_navlink_container__hyVYo"};